import { Routes } from '@angular/router';
import { authGuard } from './guards/auth.guard';
import { permissionGuard } from './guards/permission.guard';

const PERM_RESERVATION_CREATE = ['reservations.add'];
const PERM_RESERVATION_BROWSE = ['reservations.browse'];
const PERM_RESERVATION_READ = ['reservations.read'];
const PERM_RESERVATION_EDIT = ['reservations.edit'];
const PERM_REVISION_BROWSE = ['revisions.browse'];

export const routes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./common/splash/splash-screen.component').then(m => m.SplashScreenComponent),
    data: { hideNav: true },
  },
  {
    path: 'login',
    loadComponent: () =>
      import('./views/app-login/app-login.component').then(m => m.AppLoginComponent),
    data: { hideNav: true },
  },
  {
    path: 'landing',
    loadComponent: () =>
      import('./views/landing/landing.component').then(m => m.LandingComponent),
    data: { hideNav: true },
  },
  {
    path: 'onBoard',
    loadComponent: () =>
      import('./views/onboarding/onboarding.component').then(m => m.OnboardingComponent),
    data: { hideNav: true },
  },
  {
    path: 'inicio',
    loadComponent: () =>
      import('./views/inicio/inicio.component').then(m => m.InicioComponent),
    canActivate: [authGuard],
  },
  {
    path: 'reservas-list',
    loadComponent: () =>
      import('./views/reserva/reservas-list/reservas-list.component').then(m => m.ReservasListComponent),
    canActivate: [authGuard, permissionGuard],
    data: { permissions: PERM_RESERVATION_BROWSE },
  },
  {
    path: 'detalle-reserva',
    loadComponent: () =>
      import('./views/reserva/reserva.component').then(m => m.ReservaComponent),
    canActivate: [authGuard, permissionGuard],
    data: { permissions: PERM_RESERVATION_READ },
  },
  {
    path: 'about',
    loadComponent: () =>
      import('./common/about/about.component').then(m => m.AboutComponent),
    canActivate: [authGuard],
  },
  {
    path: 'perfil',
    loadComponent: () =>
      import('./views/profile/profile.component').then(m => m.ProfileComponent),
    canActivate: [authGuard],
  },
  {
    path: 'terms',
    loadComponent: () =>
      import('./common/terms-conditions/terms-conditions.component').then(m => m.TermsConditionsComponent),
    data: { hideNav: true },
  },
  {
    path: 'asistencia',
    loadComponent: () =>
      import('./views/asistencia-en-ruta/asistencia-en-ruta.component').then(m => m.AsistenciaEnRutaComponent),
    canActivate: [authGuard],
  },
  {
    path: 'reservar',
    loadComponent: () =>
      import('./views/reserva/search-categ/search-categ.component').then(m => m.SearchCategComponent),
    canActivate: [authGuard, permissionGuard],
    data: { permissions: PERM_RESERVATION_CREATE },
  },
  {
    path: 'select-veh',
    loadComponent: () =>
      import('./views/reserva/search-vehiculo/search-vehiculo.component').then(m => m.SearchVehiculoComponent),
    canActivate: [authGuard, permissionGuard],
    data: { permissions: PERM_RESERVATION_CREATE },
  },
  {
    path: 'docs',
    loadComponent: () =>
      import('./views/documentos/documentos.component').then(m => m.DocumentosComponent),
    canActivate: [authGuard],
  },
  {
    path: 'form-docs',
    loadComponent: () =>
      import('./views/documentos/form.documentos/form.documentos.component').then(m => m.FormDocumentosComponent),
    canActivate: [authGuard],
  },
  {
    path: 'devolucion',
    loadComponent: () =>
      import('./views/reserva/devolucion/devolucion.component').then(m => m.DevolucionComponent),
    canActivate: [authGuard, permissionGuard],
    data: { permissions: PERM_RESERVATION_EDIT },
  },
  {
    path: 'normativa',
    loadComponent: () =>
      import('./views/normativa/normativa.component').then(m => m.NormativaComponent),
    canActivate: [authGuard],
  },
  {
    path: 'revisiones',
    loadComponent: () =>
      import('./views/revisiones/revisiones.component').then(m => m.RevisionesComponent),
    canActivate: [authGuard, permissionGuard],
    data: { permissions: PERM_REVISION_BROWSE },
  },
  {
    path: 'revision-detail',
    loadComponent: () =>
      import('./views/revisiones/revision-detail/revision-detail.component').then(m => m.RevisionDetailComponent),
    canActivate: [authGuard, permissionGuard],
    data: { permissions: PERM_REVISION_BROWSE },
  },
  {
    path: 'rev-items',
    loadComponent: () =>
      import('./views/revisiones/revision-items/revision-items.component').then(m => m.RevisionItemsComponent),
    canActivate: [authGuard, permissionGuard],
    data: { permissions: PERM_REVISION_BROWSE },
  },
  {
    path: 'rev-fotos',
    loadComponent: () =>
      import('./views/revisiones/revision-fotos/revision-fotos.component').then(m => m.RevisionFotosComponent),
    canActivate: [authGuard, permissionGuard],
    data: { permissions: PERM_REVISION_BROWSE },
  },
  {
    path: 'siniestros',
    loadComponent: () => import('./views/siniestros/siniestros.component').then(m => m.SiniestrosComponent),
    canActivate: [authGuard],
  },
  {
    path: '404',
    loadComponent: () =>
      import('./views/page-404/page-404.component').then(m => m.Page404Component),
    data: { hideNav: true },
  },
  {
    path: '**',
    loadComponent: () =>
      import('./views/page-404/page-404.component').then(m => m.Page404Component),
    data: { hideNav: true },
  },
];
